<template>
  <section class="cookie-container">
    <div class="cookie-banner">
      <div>
        <h2>Nos importamos com a sua privacidade</h2>
        <p>
          Em busca de melhorar sua experiência em nosso site, tornando seu acesso mais eficiente e personalizado, utilizamos cookies capazes de coletar e
          armazenar dados relativos à sua navegação e preferências online. Podemos compartilhar os dados coletados com nossos parceiros comerciais, para que os
          utilizem para finalidades relacionadas à promoção de anúncios e análises das informações encontradas por meio do tratamento dos dados.
          <cookies-banner-modal :accept-terms.sync="acceptTerms" @close="close" />
        </p>
      </div>
      <div class="buttons-container">
        <v-btn
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonBackground }"
          :class="{ 'mb-5': screenType !== 'desktop' }"
          :block="isMobile"
          outlined
          class="button-height mr-5"
          @click="close(false)"
          >RECUSAR</v-btn
        >
        <v-btn
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonFont }"
          :class="{ 'mb-5': screenType !== 'desktop' }"
          :block="isMobile"
          class="button-height accept"
          @click="close(true)"
          >ACEITAR</v-btn
        >
      </div>
    </div>
  </section>
</template>

<script>
import { screenTypeMixin } from '@/mixins/screen-type'
export default {
  components: {
    CookiesBannerModal: () => import('@/components/modals/CookiesBannerModal.vue')
  },
  mixins: [screenTypeMixin],
  data() {
    return {
      acceptTerms: false
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    pixelCode() {
      return this.$store.getters.PIXEL
    },
    googleAnalyticsCode() {
      return this.$store.getters.GOOGLE_ANALYTICS
    }
  },
  methods: {
    close(acceptTerms) {
      this.acceptTerms = acceptTerms
      localStorage.setItem('pixelCookiePermission', acceptTerms)
      localStorage.setItem('googleAnalyticsCookiePermission', acceptTerms)
      this.$emit('close', this.acceptTerms)
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 1024px;

section.cookie-container {
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
}

.cookie-banner {
  background: #fff;
  padding: 33px 80px 32px;
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: 0px -2px 20px rgba(0, 0, 0, 0.2);
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 50px;
  align-items: center;

  & h2 {
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    color: #4b525a;
    padding-bottom: 10px;
  }

  & p {
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
    color: #6b7580;
  }

  & button {
    padding: 0 50px !important;
  }

  & label {
    font-size: 14px !important;
    color: #6f6f6f !important;
  }

  span.know-more {
    color: #0079f2;
    cursor: pointer;
    text-decoration: underline;
  }

  & .v-messages {
    display: none;
  }

  .buttons-container {
    display: flex;
    align-items: center;
  }
}

@media screen and (max-width: $tablet-size) {
  .cookie-banner {
    grid-template-columns: 1fr;
    gap: 0;
    padding: 33px 60px 32px;
  }
}

@media screen and (max-width: $phone-size) {
  .cookie-banner {
    grid-template-columns: 1fr;
    gap: 0;

    & h2 {
      font-size: 16px;
    }

    & p {
      font-size: 14px;
    }

    & label {
      font-size: 14px;
    }
  }

  .buttons-container {
    display: grid !important;
    grid-template-columns: 1fr;
  }

  .accept {
    grid-row: 1;
  }
}
</style>
